export const kApiListSWRKeys = {
  lists: "/api/lists",
  getLists: "/api/lists/fetch",
  addList: "/api/lists",
  deleteList: (listId: string) => `/api/lists/${listId}`,
  getList: (listId: string) => `/api/lists/${listId}`,
  updateList: (listId: string) => `/api/lists/${listId}`,
};

export const kApiWorkspaceSWRKeys = {
  workspaces: "/api/workspaces",
  getWorkspaces: "/api/workspaces",
  addWorkspace: "/api/workspaces",
  deleteWorkspace: (workspaceId: string) => `/api/workspaces/${workspaceId}`,
  getWorkspace: (workspaceId: string) => `/api/workspaces/${workspaceId}`,
  updateWorkspace: (workspaceId: string) => `/api/workspaces/${workspaceId}`,
  transferList: "/api/workspaces/transferList",
};

export const kApiChoreSWRKeys = {
  addChore: (listId: string) => `/api/lists/${listId}/chores`,
  deleteChore: (listId: string, choreId: string) =>
    `/api/lists/${listId}/chores/${choreId}`,
  getChore: (listId: string, choreId: string) =>
    `/api/lists/${listId}/chores/${choreId}`,
  updateChore: (listId: string, choreId: string) =>
    `/api/lists/${listId}/chores/${choreId}`,
  getChoresByList: (listId: string) => `/api/lists/${listId}/chores/getByList`,
  getChoresByAssignee: "/api/chores/getByAssignee",
  getSubchores: (listId: string, choreId: string) =>
    `/api/lists/${listId}/chores/${choreId}/getSubchores`,
};

export const kApiParticipantSWRKeys = {
  getParticipants: () => `/api/participants/fetchMany`,
  getParticipant: () => `/api/participants/fetchOne`,
  getUserParticipantRequests: () => `/api/participants/getUserRequests`,
  deleteParticipant: () => `/api/participants/remove`,
  respondToParticipantRequest: () => `/api/participants/respond`,
  updateParticipant: () => `/api/participants/update`,
  addParticipant: () => `/api/participants`,
};

export const kApiApiKeySWRKeys = {
  listApiKeys: (listId: string) => `/api/lists/${listId}/api-keys`,
  workspaceApiKeys: (workspaceId: string) =>
    `/api/workspaces/${workspaceId}/api-keys`,
};

export const kApiStatusSWRKeys = {
  getListStatuses: (listId: string) => `/api/lists/${listId}/statuses/fetch`,
  addStatus: (listId: string) => `/api/lists/${listId}/statuses`,
  deleteStatus: (listId: string, statusId: string) =>
    `/api/lists/${listId}/statuses/${statusId}`,
  updateStatus: (listId: string, statusId: string) =>
    `/api/lists/${listId}/statuses/${statusId}`,
  getStatus: (listId: string, statusId: string) =>
    `/api/lists/${listId}/statuses/${statusId}`,
  updateStatusWeight: (listId: string) =>
    `/api/lists/${listId}/statuses/weights`,
};

export const kApiPrioritiesWRKeys = {
  getListPriorities: (listId: string) =>
    `/api/lists/${listId}/priorities/fetch`,
  addPriority: (listId: string) => `/api/lists/${listId}/priorities`,
  deletePriority: (listId: string, priorityId: string) =>
    `/api/lists/${listId}/priorities/${priorityId}`,
  updatePriority: (listId: string, priorityId: string) =>
    `/api/lists/${listId}/priorities/${priorityId}`,
  getPriority: (listId: string, priorityId: string) =>
    `/api/lists/${listId}/priorities/${priorityId}`,
  updatePriorityWeight: (listId: string) =>
    `/api/lists/${listId}/priorities/weights`,
};

export const kApiSearchSWRKeys = {
  search: "/api/search",
};

export const kApiTagSWRKeys = {
  getListTags: (listId: string) => `/api/lists/${listId}/tags/fetch`,
  addTag: (listId: string) => `/api/lists/${listId}/tags`,
  deleteTag: (listId: string, tagId: string) =>
    `/api/lists/${listId}/tags/${tagId}`,
  updateTag: (listId: string, tagId: string) =>
    `/api/lists/${listId}/tags/${tagId}`,
  getTag: (listId: string, tagId: string) =>
    `/api/lists/${listId}/tags/${tagId}`,
};
